export default {
    root: {
        background: '{content.background}',
        borderRadius: '{content.border.radius}',
        color: '{content.color}',
        shadow: '0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)'
    },
    body: {
        padding: '1.5rem',
        gap: '0.75rem'
    },
    caption: {
        gap: '0.5rem'
    },
    title: {
        fontSize: '1.25rem',
        fontWeight: '500'
    },
    subtitle: {
        color: '{text.muted.color}'
    }
};
